import { useEffect, useState, useCallback, useRef } from "react";
import { baseURLAdmin, commonHeaderAdmin } from "api/constants";

export function useFetchDetail(payload) {
  const { url, id, params } = payload;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const abortRef = useRef(null);

  const fetchDetail = useCallback(async () => {
    if (!id) return;

    if (abortRef.current) {
      abortRef.current.abort();
    }

    const filteredParams = Object.fromEntries(
      Object.entries(params || {}).filter(([, value]) => value !== undefined)
    );
    const queryString = new URLSearchParams(filteredParams).toString();

    const controller = new AbortController();
    abortRef.current = controller;

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${baseURLAdmin}${url}/${id}?${queryString}`, {
        signal: controller.signal,
        method: "GET",
        ...commonHeaderAdmin,
      });

      if (!res.ok) {
        throw new Error("Fetch detail failed");
      }

      const json = await res.json();
      setData(json);
    } catch (err) {
      console.log(err?.message);
      if (err.name === "AbortError") return;
      if (err?.message === "Fetch detail failed") {
        setData([]);
        return;
      }
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [url, id, params]);

  useEffect(() => {
    fetchDetail();

    return () => {
      if (abortRef.current) abortRef.current.abort();
    };
  }, [fetchDetail]);

  return {
    data,
    loading,
    error,
    refetch: fetchDetail,
  };
}
